var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShield(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--noto",
    width: 32,
    height: 32,
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M16.77 19.75c-1 0-1.7.8-1.7 1.8v.1c-1.5 25.91 3.03 59.27 24.01 83.52c12.1 14.7 23.91 18.53 24.51 18.73c0 0 .28.09.54.09s.57-.1.57-.1c.5-.2 12.48-4.02 24.49-18.72c19.91-24.21 24.01-58.82 24.01-83.52v-.1c0-1-.8-1.8-1.7-1.8c-.3 0-29.11-1-46.01-15.3c-.7-.6-1.7-.6-2.4 0c-17.11 14.2-46.02 15.2-46.32 15.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#84B0C1",
    d: "M111.49 19.75c-.3 0-29.11-1-46.01-15.3c-.4-.35-.83-.45-1.24-.45h-.11v120c.27-.01.62-.11.62-.12c.6-.25 12.44-4 24.44-18.7c19.91-24.21 24.01-58.82 24.01-83.52v-.1c0-1.01-.8-1.81-1.71-1.81z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2F7889",
    d: "M26.33 28.31c-.82 0-1.02 1.02-1.02 1.74v.1c0 19.72 3.06 47.4 19 66.71c9.6 11.75 19 14.81 19.41 14.91l.41.1l.41-.1c.41-.1 9.81-3.17 19.41-14.91c15.94-19.31 19-46.89 19-66.71v-.1c0-.82-.41-1.43-1.23-1.43h.1c-.2 0-23.19-.82-36.67-12.16c-1.19-.98-1.94-.2-1.94-.2C49.63 27.6 26.64 28.31 26.33 28.31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9E3E6",
    d: "M29.18 30.07c-.76 0-.94.96-.94 1.64v.1c0 18.57 2.83 44.65 17.57 62.84c8.88 11.07 17.57 13.95 17.95 14.05l.38.1l.38-.1c.38-.1 9.07-2.98 17.95-14.05c14.73-18.19 17.57-44.17 17.57-62.84v-.1c0-.77-.38-1.35-1.13-1.35H99c-.19 0-21.44-.77-33.91-11.45c-.94-.95-1.79-.19-1.79-.19C50.72 29.4 29.47 30.07 29.18 30.07z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M98.89 30.36h.09c-.19 0-21.44-.77-33.91-11.45c-.34-.34-.66-.46-.94-.47v90.35l.38-.1c.38-.1 9.07-2.98 17.95-14.05c14.73-18.19 17.57-44.17 17.57-62.84v-.1c-.01-.76-.38-1.34-1.14-1.34z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.63,
    cy: 14.44,
    r: 1.93,
    fill: "#37474F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.21,
    cy: 19.67,
    r: 1.93,
    fill: "#37474F"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95.01,
    cy: 23.21,
    r: 1.93,
    fill: "#37474F"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.15,
    cy: 25.14,
    r: 1.93,
    fill: "#37474F"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.57,
    cy: 36.94,
    r: 1.93,
    fill: "#37474F"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.02,
    cy: 50.76,
    r: 1.93,
    fill: "#37474F"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 64.08,
    cy: 118.11,
    r: 1.93,
    fill: "#37474F"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.4,
    cy: 112.71,
    r: 1.93,
    fill: "#37474F"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.74,
    cy: 102.71,
    r: 1.93,
    fill: "#37474F"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.81,
    cy: 91.27,
    r: 1.93,
    fill: "#37474F"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.67,
    cy: 79,
    r: 1.93,
    fill: "#37474F"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 104.27,
    cy: 64.65,
    r: 1.93,
    fill: "#37474F"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 70.15,
    cy: 13.8,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 81.73,
    cy: 19.03,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 94.53,
    cy: 22.57,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 107.66,
    cy: 24.5,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 108.09,
    cy: 36.3,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.53,
    cy: 50.12,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 63.6,
    cy: 117.47,
    r: 1.93,
    fill: "#EEE"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.92,
    cy: 112.07,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 85.26,
    cy: 102.07,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.33,
    cy: 90.63,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 99.19,
    cy: 78.36,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 103.79,
    cy: 64.01,
    r: 1.93,
    fill: "#B9E4EA"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.97,
    cy: 14.44,
    r: 1.93,
    fill: "#2F7889"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 46.39,
    cy: 19.67,
    r: 1.93,
    fill: "#2F7889"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.59,
    cy: 23.21,
    r: 1.93,
    fill: "#2F7889"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.45,
    cy: 25.14,
    r: 1.93,
    fill: "#2F7889"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.02,
    cy: 36.94,
    r: 1.93,
    fill: "#2F7889"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.58,
    cy: 50.76,
    r: 1.93,
    fill: "#2F7889"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.19,
    cy: 112.71,
    r: 1.93,
    fill: "#2F7889"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.86,
    cy: 102.71,
    r: 1.93,
    fill: "#2F7889"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.79,
    cy: 91.27,
    r: 1.93,
    fill: "#2F7889"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.92,
    cy: 79,
    r: 1.93,
    fill: "#2F7889"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.33,
    cy: 64.65,
    r: 1.93,
    fill: "#2F7889"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.54,
    cy: 13.8,
    r: 1.93,
    fill: "#EEE"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.95,
    cy: 19.03,
    r: 1.93,
    fill: "#EEE"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 33.16,
    cy: 22.57,
    r: 1.93,
    fill: "#EEE"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.02,
    cy: 24.5,
    r: 1.93,
    fill: "#EEE"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.59,
    cy: 36.3,
    r: 1.93,
    fill: "#EEE"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.15,
    cy: 50.12,
    r: 1.93,
    fill: "#EEE"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.76,
    cy: 112.07,
    r: 1.93,
    fill: "#EEE"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.42,
    cy: 102.07,
    r: 1.93,
    fill: "#EEE"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.36,
    cy: 90.63,
    r: 1.93,
    fill: "#EEE"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.49,
    cy: 78.36,
    r: 1.93,
    fill: "#EEE"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.89,
    cy: 64.01,
    r: 1.93,
    fill: "#EEE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.bb418057.svg";
export { ForwardRef as ReactComponent };